import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { Text, View } from 'react-native';
export default function SectionContainer({ title, rightComponent, children, }) {
    return (_jsxs(View, { className: "gap-3", children: [_jsxs(View, { className: "flex-row items-center gap-2", children: [_jsx(Text, { className: "font-pretendard-bold text-[18px] leading-[26px] text-black", children: title }), rightComponent] }), children] }));
}
